export const environment = {
  production: true,
  baseUrl: "https://admin-api.valorenv.com/",
  version: "1.0.51",
  appName: "production",
  dbPassword: "]c+c5{R8Lu7vgMk<",
  sentryDsn: "https://36f13f7d56294cc0a213d4b0b7d23349@o86942.ingest.sentry.io/5400576",
};
